import React, { useState } from 'react'
import { Combobox, ComboboxInput, ComboboxButton, ComboboxOption, ComboboxOptions, Field, Label } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid'

function normalizeOptions(options) {
  return options.map((option) =>
    typeof option === 'string' ? { name: option } : option
  )
}

function filterOptions(query, options) {
  if(query === "") {
    return options;
  }

  return options.filter((option) => {
    return option.name.toLowerCase().includes(query.toLowerCase());
  })
}

export default function FormInputSelect({ selected, setSelected, options, label }) {
  const [ query, setQuery ] = useState('');

  const normalizedOptions = normalizeOptions(options);
  const filteredOptions = filterOptions(query, normalizedOptions)

  return (
    <Field>
      <Label className="block text-sm font-normal text-gray-700 mb-1">{label}</Label>
      <Combobox value={selected} onChange={setSelected} onClose={() => setQuery('')}>
        <div className="relative w-64">
          <ComboboxInput
            displayValue={(option) => option?.name}
            onChange={(event) => setQuery(event.target.value)}
            className="
              w-64 rounded-md bg-white/5 py-1.5 pr-8 pl-3 text-sm/6
              border-gray-300 focus:border-teal-500 focus:ring-teal-500
              focus:not-data-focus:outline-none
            "
          />
          <ComboboxButton className="group absolute inset-y-0 right-0 px-2.5">
            <ChevronDownIcon className="size-4 fill-gray-600 group-data-hover:fill-white" />
          </ComboboxButton>
        </div>
        <ComboboxOptions
          anchor="bottom"
          className="
            z-50 mt-3 w-64 rounded-sm bg-white border-gray-400 shadow-md border-white/5 [--anchor-gap:--spacing(1)] empty:invisible
            transition duration-100 ease-in data-leave:data-closed:opacity-0
          "
        >
          {filteredOptions.map((option) => (
            <ComboboxOption
              key={option.id || option.name}
              value={option}
              className="
                data-focus:bg-teal-100 cursor-pointer
                group flex items-center gap-2 px-4 py-2 select-none data-focus:bg-white/10
                hover:bg-stone-100
              "
            >
              {option.name}
            </ComboboxOption>
          ))}
        </ComboboxOptions>
      </Combobox>
    </Field>
  )
}
